export default __webpack_public_path__ + "static/media/italo-header.a0d935e6.svg";